import onScan from "onscan.js";
import ScannerModule from "@/store/modules/scanner";
import { getProductCategoryByBarcode } from "@/dexie/product-category";
import { DBErrors } from "@/constants/errors/db";
import { LogService } from "@/services/logging";
import { PCTypes } from "@/types/db/product-category";
import { addToBasket } from "@/utils/vue-helpers/product-category";

let attached = false;

//     // Alternative to document.addEventListener('scan')

export function attachScanner() {
  if (attached) {
    // scanner already attached
    LogService.info(`Scanner: already attached with attached options`, {
      params: onScan.getOptions(document),
    });
    return;
  }
  // Enable scan events for the entire document
  onScan.attachTo(document, {
    // suffixKeyCodes: [9, 13], // enter-key expected at the end of a scan
    suffixKeyCodes: [13], // enter-key expected at the end of a scan
    reactToPaste: false, // Compatibility to built-in scanners in paste-mode (as opposed to keyboard-mode)
    // reactToKeydown: true,
    // reactToKeyDown: true,
    minLength: 6,
    avgTimeByChar: 75,
    timeBeforeScanTest: 110,
    onScan: function (sCode: string, iQty: number) {
      // Alternative to document.addEventListener('scan')
      // ScanModule.setValue('');
      console.log("Scanned", sCode);
      LogService.info(`Scanner: scanner triggered, value: ${sCode}`);
      ScannerModule.setValue(sCode);
      ScannerModule.toggle();
    },
    onScanError: function (oDebug) {
      LogService.info(`onScanError triggered, error attached`, {
        params: oDebug,
      });
      // console.log(`onScanError triggered, error attached`);
      // console.log(oDebug);
    },
    keyCodeMapper: function (oEvent) {
      // Look for special keycodes or other event properties specific to
      // your scanner. Cause by default, onScan takes only letters and numbers
      if (
        ["-", "_", "=", ":", "{", "}", ",", '"', "'", "/", "."].includes(
          oEvent.key
        )
      ) {
        return oEvent.key;
      }
      // Fall back to the default decoder in all other cases
      return onScan.decodeKeyEvent(oEvent);
    },
  });
  attached = true;
}

export function detachScanner() {
  if (!attached) {
    return;
  }

  onScan.detachFrom(document);
  attached = false;
}

export function attachedVueElement() {
  ScannerModule.addListener();
  attachScanner();
}

export function detachVueElement() {
  ScannerModule.removeListener();

  if (ScannerModule.noListeners) {
    detachScanner();
  }
}

/**
 * Adds a scanned product (identified by barcode) to the active order with quantity 1.
 * Resolves the matching price from local DB and delegates to the shared `addToBasket`
 * helper so existing lines for the same product get incremented.
 *
 * Assumption: each retail price has exactly one retail option, so `buildOrderLineDto`'s
 * `price.retail[0]` selection inside `addToBasket` is unambiguous.
 */
export async function addScannedProductToBasket(barcode: string) {
  const psc = await getProductCategoryByBarcode(barcode);
  if (!psc) {
    LogService.info(DBErrors.NotFoundElement);
    return;
  }

  const matchedPrice = psc.prices.find((p) =>
    p.retail.some((r) => r.barcode === barcode)
  );
  if (!matchedPrice) {
    return;
  }

  await addToBasket({
    productCategory: psc,
    price: matchedPrice,
    isRetail: psc.type === PCTypes[PCTypes.Retail],
    pssQuantity: 1,
  });
}
